import type { TeamCalendarResponse, UserListRecord } from "../../shared/models";
import { CalendarView } from "./CalendarView";

interface CrewProfileDrawerProps {
  open: boolean;
  profile: (UserListRecord & { role_names?: string[]; email: string }) | null;
  calendar: TeamCalendarResponse | null;
  onClose: () => void;
}

export function CrewProfileDrawer({ open, profile, calendar, onClose }: CrewProfileDrawerProps) {
  if (!open || !profile) {
    return null;
  }

  return (
    <div className="drawer-backdrop" onClick={onClose}>
      <aside className="drawer" onClick={(event) => event.stopPropagation()}>
        <div className="drawer-header">
          <div>
            <h2>{profile.name}</h2>
            <p>{profile.department ?? "No department set"}</p>
          </div>
          <button className="ghost" onClick={onClose}>Close</button>
        </div>
        <div className="drawer-meta">
          <a href={`tel:${profile.phone ?? ""}`}>{profile.phone ?? "No phone"}</a>
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
        </div>
        <div className="tag-row">
          {(profile.role_names ?? []).map((role_name) => (
            <span key={role_name} className="tag neutral">{role_name}</span>
          ))}
        </div>
        <p className="notes-block">{profile.notes ?? "No crew notes."}</p>
        {calendar ? (
          <CalendarView
            mode="personal"
            users={calendar.users}
            events={calendar.events}
            allowedViews={["day", "week", "month", "year"]}
            initialView="month"
            initialDate={calendar.events[0]?.start_date}
          />
        ) : (
          <p className="muted">Loading calendar…</p>
        )}
      </aside>
    </div>
  );
}
